export enum Role {
	Administrator = "Administrator",
	User = "User",
	SuperUser = "SuperUser",
	Unknown = "",
}
